/**
 * Re-export section label resolution from the canonical registry (#1330 dot-notation ids).
 */
export { getSectionLabel } from '../constants/sectionIds';
